import Tooltip from "./Tooltip";
import $ from 'jquery'

export default class ComponentTooltip extends Tooltip {

    constructor({extraClass})
    {
        super(null);
        this.extraClass = extraClass;
        this._disabled = false;
        this._visible = true;

        this.state = {
            text: ""
        }

        this.onStatePropertyChanged('text', text => this.$el.text(text))
    }

    templateHtml()
    {
        return "<div class='simpleTooltip'/>"
    }

    afterRender()
    {
        super.afterRender();
        if (this.extraClass)
            this.$el.addClass(this.extraClass);
    }

    show() {
        $('body').on('mousemove', this.bind(this.moveAfterCursor));
        this.$el.css("visibility", "visible")
    }

    hide() {
        $('body').off('mousemove');
        this.$el.css("visibility", "hidden")
    }

}




// WEBPACK FOOTER //
// ./web/js/ComponentTooltip.js